"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _clsx6 = _interopRequireDefault(require("clsx"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _reactRouter = require("react-router");
var _commonRichText = require("@mmc/common-rich-text");
var _dateLabelContainer = _interopRequireDefault(require("../components/date-label-container"));
var _text = require("@mmc/text");
var _commonCta = require("@mmc/common-cta");
var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");
var _textBlockArticle = _interopRequireDefault(require("../styles/text-block-article.css"));
var _textBlockArticle2 = _interopRequireDefault(require("./text-block-article.props/text-block-article.defaultProps"));
var _textBlockArticle3 = _interopRequireDefault(require("./text-block-article.props/text-block-article.propTypes"));
/**
 * ## TextBlockArticle - component
 *
 * A simple compact Text Block Article component
 */

var dataUtils = new _mmcDataUtilities["default"]();
var shouldUseDataOrDefaultProps = dataUtils.shouldUseDataOrDefaultProps,
  handleNestedProp = dataUtils.handleNestedProp,
  renderEmptyString = dataUtils.renderEmptyString;
var TextBlockArticle = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(TextBlockArticle, _React$Component);
  TextBlockArticle.resourceType = function resourceType() {
    return 'ArticleText_1_0_0';
  };
  TextBlockArticle.renderHeadline = function renderHeadline(theme, mainHeading, headlineTag, width, headlineWeight) {
    var _clsx, _clsx2, _clsx3, _clsx4;
    if ((0, _isEmpty2["default"])(mainHeading)) {
      return '';
    }
    var headingTagMap = {
      h1: 'headingOne',
      h2: 'headingTwo',
      h3: 'headingThree',
      h4: 'headingFour',
      h5: 'headingFive',
      h6: 'headingSix'
    };
    var headingTagMapClass = (headingTagMap == null ? void 0 : headingTagMap[headlineTag]) || 'headingOne';
    switch (width) {
      case 'span100':
        return /*#__PURE__*/_react["default"].createElement(_text.Text, {
          tag: headlineTag || 'h1',
          text: mainHeading,
          className: (0, _clsx6["default"])(theme[headingTagMapClass], _textBlockArticle["default"].headline, _textBlockArticle["default"].mainHeader, (_clsx = {}, _clsx[_textBlockArticle["default"].fontWeight400] = headlineWeight === '400', _clsx))
        });
      case 'span75':
        return /*#__PURE__*/_react["default"].createElement(_text.Text, {
          tag: headlineTag || 'h2',
          text: mainHeading,
          className: (0, _clsx6["default"])(theme[headingTagMapClass], _textBlockArticle["default"].headline, _textBlockArticle["default"].mainHeader, (_clsx2 = {}, _clsx2[_textBlockArticle["default"].fontWeight400] = headlineWeight === '400', _clsx2))
        });
      case 'span50':
        return /*#__PURE__*/_react["default"].createElement(_text.Text, {
          tag: headlineTag || 'h3',
          text: mainHeading,
          className: (0, _clsx6["default"])(theme[headingTagMapClass], _textBlockArticle["default"].headline, _textBlockArticle["default"].mainHeader, (_clsx3 = {}, _clsx3[_textBlockArticle["default"].fontWeight400] = headlineWeight === '400', _clsx3))
        });
      default:
        return /*#__PURE__*/_react["default"].createElement(_text.Text, {
          tag: headlineTag || 'h1',
          text: mainHeading,
          className: (0, _clsx6["default"])(theme[headingTagMapClass], _textBlockArticle["default"].headline, _textBlockArticle["default"].mainHeader, (_clsx4 = {}, _clsx4[_textBlockArticle["default"].fontWeight400] = headlineWeight === '400', _clsx4))
        });
    }
  };
  TextBlockArticle.renderTags = function renderTags(theme, tags, componentTheme) {
    if ((0, _isEmpty2["default"])(tags)) {
      return '';
    }
    return tags.map(function (item) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _textBlockArticle["default"].tagBox + " " + (componentTheme !== undefined ? theme[componentTheme] : '')
      }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
        theme: theme,
        data: {
          label: renderEmptyString(item),
          priority: 'lowIcon'
        },
        classes: [_textBlockArticle["default"].headerLink + " " + (componentTheme !== undefined ? theme[componentTheme] : '')]
      }));
    });
  };
  function TextBlockArticle(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    TextBlockArticle.renderHeadline = TextBlockArticle.renderHeadline.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = TextBlockArticle.prototype;
  _proto.render = function render() {
    var _clsx5;
    var _this$props = this.props,
      data = _this$props.data,
      theme = _this$props.theme,
      defaultData = _this$props.defaultData;
    var componentData = shouldUseDataOrDefaultProps(data, defaultData);
    var label = componentData.label,
      enableArticleDate = componentData.enableArticleDate,
      enableReadTime = componentData.enableReadTime,
      articleAuthor = componentData.articleAuthor,
      componentTheme = componentData.theme,
      date = componentData.date,
      articleInformation = componentData.articleInformation,
      alignment = componentData.alignment,
      headlineTag = componentData.headlineTag,
      headlineWeight = componentData.headlineWeight,
      spanText = componentData.spanText,
      socialSharingLabel = componentData.socialSharingLabel,
      socialsharingLinks = componentData.socialsharingLinks;
    var textAlignment = alignment || 'left';
    var renderedHeadline = TextBlockArticle.renderHeadline(theme, articleInformation.sectionHeading, headlineTag, spanText, headlineWeight);
    var alignmentClasses = theme['col-sm-offset-1'] + " " + _textBlockArticle["default"].leftAligned;
    if (textAlignment) {
      var _alignment = textAlignment.toLowerCase();
      if (_alignment === 'right') {
        alignmentClasses = theme['col-sm-offset-3'] + " " + _textBlockArticle["default"].rightAligned;
      } else if (_alignment === 'center') {
        alignmentClasses = theme['col-sm-offset-2'] + " " + _textBlockArticle["default"].centerAligned;
      }
    }

    // Check there is anything to even render
    if ((0, _isEmpty2["default"])(renderedHeadline)) {
      return '';
    }
    // Either headline or message is not empty so render the component
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['container-fluid'] + " " + _textBlockArticle["default"].textWrapper + " " + (componentTheme !== undefined ? theme[componentTheme] : ''),
      automation: "text-block-article"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.row + "  " + _textBlockArticle["default"].innerTextWrapper
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + theme['col-sm-8'] + " " + alignmentClasses + " " + _textBlockArticle["default"].headline,
      style: textAlignment ? {
        textAlign: textAlignment
      } : {}
    }, label && /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx6["default"])(theme.labelMedium, _textBlockArticle["default"].subHeadline)
    }, label), renderedHeadline, articleAuthor && /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
      theme: theme,
      html: articleAuthor,
      className: "" + _textBlockArticle["default"].author
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx6["default"])(_textBlockArticle["default"].socialsharingLinks, (_clsx5 = {}, _clsx5[_textBlockArticle["default"].left] = alignment === 'left', _clsx5[_textBlockArticle["default"].right] = alignment === 'right', _clsx5))
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _textBlockArticle["default"].socialSharingLabel
    }, socialSharingLabel), socialsharingLinks.map(function (link) {
      return /*#__PURE__*/_react["default"].createElement("a", {
        className: _textBlockArticle["default"].link,
        href: handleNestedProp(link, 'link.url'),
        "aria-label": handleNestedProp(link, 'link.label'),
        target: link != null && link.openNewTab ? "_blank" : undefined
      }, /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
        className: _textBlockArticle["default"].imageSocialLink,
        src: handleNestedProp(link, 'link.image.image'),
        alt: handleNestedProp(link, 'link.image.altText')
      }));
    })), date && /*#__PURE__*/_react["default"].createElement(_dateLabelContainer["default"], {
      date: date,
      time: articleInformation.readTime,
      theme: theme,
      enableReadTime: enableReadTime,
      enableArticleDate: enableArticleDate
    }))));
  };
  return TextBlockArticle;
}(_react["default"].Component);
TextBlockArticle.displayName = 'TextBlockArticle';
TextBlockArticle.defaultProps = {
  data: _textBlockArticle2["default"],
  defaultData: _textBlockArticle2["default"],
  theme: {}
};
var _default = (0, _reactRouter.withRouter)(TextBlockArticle);
exports["default"] = _default;